import React from "react";
import Dropdown from "../../components/CustomFields/Dropdown";
import InputField from "../../components/CustomFields/InputField";

const AddressDetails = ({ applicant, handleNestedChange, errors }) => {
  // Example state options for the dropdown. You can modify this based on your requirements.
  const stateOptions = {
    India: ["Tamil Nadu", "Andhra Pradesh", "Bihar", "Delhi", "Goa", "Gujarat"],
    USA: ["California", "Texas", "New York", "Florida", "Washington"],
    Canada: ["Ontario", "Quebec", "British Columbia", "Alberta"],
    Mexico: ["Chihuahua", "Jalisco", "Puebla", "Veracruz"],
    Other: ["Other"],
  };

  const validatePostalCode = (value, country) => {
    if (!value) return "";

    if (country === "USA") {
      return /^\d{5}$/.test(value) ? "" : "Must be exactly 5 digits";
    } else if (country === "India") {
      return /^\d{6}$/.test(value) ? "" : "Must be exactly 6 digits";
    } else {
      return /^\d{5,6}$/.test(value) ? "" : "Must be 5 or 6 digits";
    }
  };

  // Function to get the appropriate label for zipcode/pincode based on country
  const getPostalCodeLabel = (country) => {
    switch (country) {
      case "USA":
        return "Zipcode *";
      case "India":
        return "Pincode *";
      default:
        return "Postal Code *";
    }
  };

  const countryCodeMap = {
    India: "IN",
    USA: "US",
    Canada: "CA",
    Mexico: "MX",
    Other: "OT",
  };


  return (
    <section>
      <h2 className="text-lg font-bold mb-4 text-center">Address Details</h2>
      {applicant.addressList.map((address, index) => (
        <div key={index} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* Street Name 1 */}
          <InputField
            id={`streetName1-${index}`}
            label="Street Name 1 *"
            value={address.streetName1}
            onChange={(e) =>
              handleNestedChange("addressList", index, "streetName1", e.target.value)
            }
            error={errors?.addressList?.[index]?.streetName1}
          />

          {/* Street Name 2 */}
          <InputField
            id={`streetName2-${index}`}
            label="Street Name 2"
            value={address.streetName2}
            onChange={(e) =>
              handleNestedChange("addressList", index, "streetName2", e.target.value)
            }
          />

          {/* Country */}
          <Dropdown
            id={`country-${index}`}
            label="Country *"
            value={address.country}
            onChange={(e) => {
              const selectedCountry = e.target.value;
              const countryCode = countryCodeMap[selectedCountry];
              sessionStorage.setItem("selectedCountryCode", countryCode);
              handleNestedChange("addressList", index, "country", selectedCountry);
            }}
            options={["India", "USA", "Canada", "Mexico", "Other"]}
            defaultOption="Select Country"
            error={errors?.addressList?.[index]?.country}
          />


          {/* State */}
          <Dropdown
            id={`state-${index}`}
            label="State *"
            value={address.state}
            onChange={(e) => handleNestedChange("addressList", index, "state", e.target.value)}
            options={stateOptions[address.country] || []}
            defaultOption="Select State"
            error={errors?.addressList?.[index]?.state}
          />

          {/* City */}
          <InputField
            id={`city-${index}`}
            label="City *"
            value={address.city}
            onChange={(e) => handleNestedChange("addressList", index, "city", e.target.value)}
            error={errors?.addressList?.[index]?.city}
          />

          {/* Zipcode/Pincode */}
          <InputField
            id={`zipcode-${index}`}
            label={getPostalCodeLabel(address.country)}
            value={address.zipcode}
            onChange={(e) => {
              // Allow only numeric input
              let value = e.target.value.replace(/\D/g, '');

              // Enforce max length based on country
              if (address.country === "USA") {
                value = value.slice(0, 5); // Max 5 digits for USA
              } else {
                value = value.slice(0, 6); // Max 6 digits for others
              }

              handleNestedChange("addressList", index, "zipcode", value);
            }}
            error={
              errors?.addressList?.[index]?.zipcode ||
              validatePostalCode(address.zipcode, address.country)
            }
            inputMode="numeric"
            pattern="\d*"
            maxLength={address.country === "USA" ? 5 : 6} // Dynamic max length
          />
        </div>
      ))}
    </section>
  );
};

export default AddressDetails;